var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOutlook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svgexport-1 (4) 1",
    clipPath: "url(#clip0_238_682)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shape308-56"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect198",
    d: "M20.1261 5.11353H8.32166V15.1162H20.1261V5.11353Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "shape77-58"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path203",
    d: "M8.1198 4.69482C7.67096 4.69482 7.30933 5.05475 7.30933 5.50274L7.31275 14.7787C7.29052 15.2156 7.53674 15.5866 8.03089 15.5866H19.693C20.1299 15.5866 20.5001 15.3396 20.4941 14.942L20.5001 5.50274C20.5001 5.05475 20.1384 4.69482 19.6896 4.69482H8.1198ZM7.95736 5.36424H19.8452L19.8486 14.9095H7.96078L7.95736 5.36424Z",
    fill: "#0071C5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "group88-60"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shape86-61"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path210",
    d: "M19.8824 5.77759L14.1835 10.3455V10.9627C14.2268 10.9723 14.2718 10.9716 14.3148 10.9607C14.3579 10.9499 14.3978 10.9292 14.4314 10.9003L19.8824 6.53335V5.77759Z",
    fill: "#0071C5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "shape87-63"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path215",
    d: "M8.56519 5.77759L14.2642 10.3455V10.9627C14.2208 10.9723 14.1758 10.9716 14.1328 10.9607C14.0898 10.9499 14.0498 10.9292 14.0162 10.9003L8.56519 6.53335V5.77759Z",
    fill: "#0071C5"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "path439",
    d: "M11.9202 19.4753V0.524902L0.5 2.41943V17.5799L11.9202 19.4753Z",
    fill: "url(#paint0_linear_238_682)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "shape85-222"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path565",
    d: "M5.91822 6.62134C4.91678 6.62134 3.28845 7.46095 3.28845 10.1026C3.28845 12.6884 4.89833 13.5134 5.89217 13.4926C7.73303 13.454 8.4464 11.5902 8.4464 10.0242C8.4464 8.32888 7.74449 6.62134 5.91822 6.62134ZM5.81415 7.94265C6.61586 7.94265 7.10336 8.75664 7.10336 9.99961C7.10336 11.099 6.69471 12.1434 5.82642 12.1434C4.7335 12.1434 4.47185 10.8191 4.48491 10.0193C4.48491 9.20637 4.84056 7.94265 5.81415 7.94265Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_238_682",
    x1: 11.92,
    y1: 10.0002,
    x2: 0.500319,
    y2: 10.0002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006BC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0077C9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_238_682"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 18.9504,
    fill: "white",
    transform: "translate(0.5 0.524902)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlook);
export default __webpack_public_path__ + "static/media/outlook.f8fefac418e0ad460020bec498862ee6.svg";
export { ForwardRef as ReactComponent };